
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/products/check-legacy",
      function () {
        return require("private-next-pages/docs/api/products/check-legacy.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/products/check-legacy"])
      });
    }
  